import { Directive } from '@angular/core';
export class BoxContentDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-content'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxContentDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxContentDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxContentDirective.ctorParameters;
}

export class BoxFooterDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-footer'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxFooterDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxFooterDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxFooterDirective.ctorParameters;
}

export class BoxToolsDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-tools'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxToolsDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxToolsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxToolsDirective.ctorParameters;
}

export class BoxHeaderDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-header'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxHeaderDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxHeaderDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxHeaderDirective.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
